import { formFieldFactory, TextFieldProps } from '@eas/common-web';
import TextField from '@material-ui/core/TextField';
import { FormattedMessage } from 'react-intl';
import { useStyles } from './login-styles';
import React from 'react';

const FormTextField = formFieldFactory((props: TextFieldProps) => {
  const classes = useStyles();
  return (
    <TextField
      label={
        <FormattedMessage
          id="TAPIS__LOGIN__USERNAME"
          defaultMessage="Uživatelské jméno"
        />
      }
      InputProps={{
        className: classes.input,
        autoComplete: 'current-password',
      }}
      fullWidth
      autoFocus
      required
      value={props.value}
      onChange={(e) => props?.onChange?.(e.target.value)}
      inputProps={{
        form: props.form,
      }}
    />
  );
});

const FormPasswordField = formFieldFactory((props: TextFieldProps) => {
  const classes = useStyles();

  return (
    <TextField
      label={
        <FormattedMessage id="TAPIS__LOGIN__PASSWORD" defaultMessage="Heslo" />
      }
      InputProps={{
        className: classes.input,
        autoComplete: 'current-password',
      }}
      type="password"
      fullWidth
      required
      value={props.value}
      onChange={(e) => props?.onChange?.(e.target.value)}
      inputProps={{
        form: props.form,
      }}
    />
  );
});

export const NameField = () => (
  <FormTextField
    name="username"
    labelOptions={{ hide: true }}
    layoutOptions={{ noUnderline: true }}
  />
);

export const PasswordField = () => (
  <FormPasswordField
    name="password"
    labelOptions={{ hide: true }}
    layoutOptions={{ noUnderline: true }}
  />
);
